import React, { FC } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

type BadgeColor = 'blue' | 'green' | 'violet' | 'white'

interface Props {
  color?: BadgeColor
  children?: React.ReactNode
  className?: string
}

export const Badge: FC<Props> = ({ color = 'blue', children, className }) => {
  return (
    <span className={clsx(s.badge, s[color], className, 'medium-12')}>
      {children}
    </span>
  )
}
